import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantMenuItems } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export const useMenuItems = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.MENU_ITEMS, orgSlug, restaurantId], () => tenantMenuItems({ orgSlug, restaurantId }));
};
